export class CheckMarkersResponse {
    visibleMarkers: any[];
    hasVisibleMarkers: boolean;
    hasInvalidMarkersNumber: boolean;
}
